module.exports = __webpack_public_path__ + "img/changeFineness-2@2x.28a78a6.jpg";